import { EDepositStatus } from "src/types";

const generateDepositCallbackUrl = (status: EDepositStatus): string => {
  const url = new URL(`/deposit-status/${status}`, window.location.origin);
  return url.toString();
};

export const generateDepositCallbackUrls = () => {
  return {
    success_url: generateDepositCallbackUrl(EDepositStatus.Success),
    cancel_url: generateDepositCallbackUrl(EDepositStatus.Cancel),
    error_url: generateDepositCallbackUrl(EDepositStatus.Error),
  };
};
